import { TicketBasket, ModifyBasket } from "@shared/modules/basket/types";
import { useCallback } from "react";

export const useGroupSale = (
  itemGroups: TicketBasket["item_groups"],
  modifyBasket: ModifyBasket
) => {
  /**
   * if isGroupSale true enter group sale mode
   * if isGroupSale false then exit from group sale mode and reset overwritten subtotal amount
   * */
  const setGroupSale = useCallback(
    (isGroupSale: boolean) => {
      let fields;

      if (isGroupSale) {
        fields = {
          is_group_sale: true,
        };
      } else {
        fields = {
          is_group_sale: false,
          subtotal_override: null,
        };
      }

      return modifyBasket(
        {
          ...fields,
        },
        // If the basket is empty, defer persisting to the backend.
        // Persisting is only necessary due to possible price changes
        { shouldPersist: Boolean(itemGroups?.length) }
      );
    },
    [modifyBasket]
  );

  /** override subtotal amount with subtotal_override value */
  const overrideSubtotal = useCallback(
    (subtotal_override: string) => {
      return modifyBasket(
        {
          subtotal_override,
        },
        { shouldPersist: true }
      );
    },
    [modifyBasket]
  );

  return {
    setGroupSale,
    overrideSubtotal,
  };
};
